import React from 'react';
import { Button, Toast, Icon } from 'antd-mobile';
import {post} from '../../../utils/request';
import { href } from '../../../utils/util';
import api from './api';
import Cookies from 'js-cookie';
import ServiceAgreenmentText from '../serviceAgreenmentText';
import VerificationCode from '../../../components/VerificationCode';

import './index.less';

var timer;

class InvitationLogin extends React.Component {
    constructor(...props) {
        super(...props);
        this.state = {
            iconType: false,
            second: 59,
            secondType: false,
            serviceAgreenmentTextStatus: false, //协议文案展示状态
            mobileNumber: '',
            // isNew: false,
            // partyType: '个人',
            ops: {},
            TPYZMtype: false,
            TPyanzhengma: ''
        };
    }

    timerFN = () => {
        const { TPyanzhengma } = this.state;
        var shouji = document.getElementById('shouji').value;
        if(!shouji || shouji.length < 11){
            Toast.info('请填写正确的手机号码',1);
            return;
        }
        this.setState({
            ops: {
                shouji:shouji,
            }
        });
        clearInterval(timer);
        let _this = this;
        post({
            url: api.getRegisterCode, 
            data: {
                phoneNumber: shouji,
                businessType: 'LOG_IN',
                imageCode: TPyanzhengma || ''
            }
        }).then((res) => {

            // console.log('验证码', res);
            if(res.result === 'success'){
                _this.setState({
                    second: 59,
                    secondType: true,
                },()=>{
                    let { second } = _this.state;
                    timer = setInterval(function() {
                            if(second<0){
                                clearInterval(timer);
                                _this.setState({
                                    secondType: false,
                                })
                            }else{
                                _this.setState({
                                    second: second--,
                                })
                            }
                        }, 1000);
                });
            }else if(res.code === 'BD001000000998'){
                clearInterval(timer);
                this.setState({
                    secondType: false,
                    TPYZMtype: true
                })
                Toast.info('图片验证码填写错误',2);
            }else if(res.code === 'BD001000000997'){
                clearInterval(timer);
                this.setState({
                    secondType: false,
                    TPYZMtype: true
                })
                Toast.info('请输入图片验证码',1);
            }else{
                this.setState({
                    TPyanzhengma: '',
                })
                Toast.info(res.msg,1);
            }
        }, (res)=>{
            this.setState({
                TPyanzhengma: '',
            })
            Toast.info(res.msg,1);
        });
    }

    submit = () => {
        var shouji,yanzhengma;
        if(document.getElementById('shouji')){
            shouji = document.getElementById('shouji').value;
            yanzhengma = document.getElementById('yanzhengma').value;
            this.setState({
                ops: {
                    shouji:shouji,
                    yanzhengma: yanzhengma
                }
            });
            if(!shouji || shouji.length < 11){
                Toast.info('请填写正确的手机号码',1);
                return;
            }
            if(!yanzhengma){
                Toast.info('请填写验证码',1);
                return;
            }
            if(!this.state.iconType){
                Toast.info('同意《慧联用户协议》后才可登录',1);
                return;
            }
        }else{
            shouji = this.state.ops.shouji;
            yanzhengma = this.state.ops.yanzhengma;
        }
        var ops = {};
        if(this.props.invitePhoneNumber){
            ops={
                // clientIp: window.returnCitySN["cip"],
                messageCode: yanzhengma,
                phoneNumber: shouji,
                invitePhoneNumber: this.props.invitePhoneNumber
            };
        }else{
            ops={
                // clientIp: window.returnCitySN["cip"],
                messageCode: yanzhengma,
                phoneNumber: shouji
            };
        }
        // if(this.state.isNew){
        //     ops.partyType = this.state.partyType;
        // }
        post({
            url: api.webMobileLogin, 
            data: ops
        }).then((res) => {
            console.log('登录', res)
            if(res.data && res.result === 'success'){
                Cookies.set('session_key', res.data.appstoken);
                Cookies.set('InvitationLoginMobile', shouji);
                this.props.onQuit(false);
                Toast.info(res.msg,1);
            }else{
                // if(res.code === 'HL001060300001'){
                //     Toast.info('请选择用户类型',2);
                //     this.setState({
                //         isNew: true
                //     });
                // }else{
                    Toast.info(res.msg,1);
                // }
            }
        }, (res)=>{
            Toast.info('登录失败',1);
        });
    }
    
    render() {
        let { iconType, second, secondType, serviceAgreenmentTextStatus, TPYZMtype, ops } = this.state;
        return (
            <div className="InvitationLoginBox">
                {/* {
                    this.state.isNew ? (
                        <div>
                            <div className="partyType">
                                <div className={this.state.partyType === '个人' ? 'select' : ''} onClick={()=>{
                                    this.setState({
                                        partyType: '个人'
                                    });
                                }}>
                                    <p>{ this.state.partyType === '个人' ? (<Icon type="check" />) : (<Icon />) }个人</p>
                                </div>
                                <div className={this.state.partyType === '企业' ? 'select' : ''} onClick={()=>{
                                    this.setState({
                                        partyType: '企业'
                                    });
                                }}>
                                    <p>{ this.state.partyType === '企业' ? (<Icon type="check" />) : (<Icon />) }企业</p>
                                </div>
                            </div>
                            <Button type="primary" onClick={this.submit}>确认</Button>
                        </div>
                    ) : ( */}
                        <div>
                            <div className="importBox">
                                <label htmlFor="shouji">
                                    <div className="inputBox">
                                        <input id="shouji" type="tel" maxLength="11" placeholder="手机号" />
                                    </div>
                                </label>
                                <label htmlFor="yanzhengma">
                                    <div className="inputBox">
                                        <input id="yanzhengma" type="tel" placeholder="验证码" />
                                    </div>
                                    { secondType ? (<div className="second secondText">{ second }S</div>) : (<div className="second" onClick={this.timerFN}>获取验证码</div>) }
                                </label>
                            </div>
                            <Button type="primary" onClick={this.submit}>登录</Button>
                            <div className="agreeBox">
                                <label onClick={()=>{
                                    this.setState({
                                        iconType: !iconType
                                    });
                                }}>
                                    { iconType ? (<Icon type="check" />) : (<Icon />) }
                                    登录即代表同意
                                </label>
                                <a onClick={()=>{
                                        this.setState({
                                            serviceAgreenmentTextStatus: true
                                        });
                                    }}>《慧联用户协议》</a>
                            </div>
                            {serviceAgreenmentTextStatus ? (
                                <ServiceAgreenmentText
                                    serviceAgreenmentTextStatus={serviceAgreenmentTextStatus}
                                    onQuit={(serviceAgreenmentTextStatus)=>{
                                        this.setState({
                                            serviceAgreenmentTextStatus
                                        });
                                    }}
                                />
                            ) : ''}
                            {TPYZMtype ? (
                                <VerificationCode
                                    onCancel={(TPyanzhengma)=>{
                                        this.setState({
                                            TPYZMtype: false,
                                            TPyanzhengma
                                        },()=>{
                                            if(TPyanzhengma){
                                                this.timerFN()
                                            }
                                        });
                                    }}
                                    phoneNumber={ops.shouji}
                                    TPYZMtype={TPYZMtype}
                                />
                            ) : ''}
                        </div>
                    {/* )
                } */}
            </div>
        );
    }
}

export default InvitationLogin;


// WEBPACK FOOTER //
// ./src/invitation/modules/login/index.js